import type { IntlShape } from 'react-intl';

export type MetricDetailCardsTooltipCopy = {
  targetUniverse: string;
  benchmark: string;
  targetReach: string;
  avgFrequency: string;
};

/**
 * Static tooltip copy of the KPIs that carry an info icon in the detail cards
 * ("States · KPI tooltips" in the design). Coverage is built in place, since it
 * quotes the report's own figures.
 */
export function getMetricDetailCardsTooltipCopy(
  formatMessage: IntlShape['formatMessage']
): MetricDetailCardsTooltipCopy {
  return {
    avgFrequency: formatMessage({
      defaultMessage: 'Average impacts per reached individual in your Target Audience.',
      id: 'doohReport.metricDetailCards.tooltip.avgFrequency'
    }),
    benchmark: formatMessage({
      defaultMessage: 'Average % on-target for DOOH campaigns on the same screen circuit without Sonata optimization.',
      id: 'doohReport.metricDetailCards.tooltip.benchmark'
    }),
    targetReach: formatMessage({
      defaultMessage: 'Number of unique people from your Target Audience reached.',
      id: 'doohReport.metricDetailCards.tooltip.targetReach'
    }),
    targetUniverse: formatMessage({
      defaultMessage:
        'Total potential Target Audience within the selected Universe level (e.g. city), the cartographic level used in the Target Audience analysis.',
      id: 'doohReport.metricDetailCards.tooltip.targetUniverse'
    })
  };
}
